import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  (theme) => ({
    experience: {
      minHeight: '128px',
      position: 'relative',
      borderRadius: '16px',
      boxSizing: 'border-box',
      gap: '8px',
      padding: '10px 16px 10px 10px',
      display: 'flex',
    },
    experienceInner: {
      display: 'flex',
      gap: '16px',
      alignItems: 'stretch',
      userSelect: 'none',
      flexGrow: 1,
      // height: '100%',
      // [theme.breakpoints.down('xs')]: {
      //   flexWrap: 'wrap',
      //   flexDirection: 'column',
      //   alignItems: 'center',
      //   justifyContent: 'center',
      // },

      [theme.breakpoints.down('xs')]: {
        gap: '8px',
      },
    },
    content: {
      justifyContent: 'space-between',
      alignItems: 'stretch',
      flexGrow: 1,
      paddingLeft: '4px',
    },
    left: {
      justifyContent: 'space-between',
      alignItems: 'stretch',
      flexGrow: 1,
    },
    titleRow: {
      alignItems: 'baseline',
      textAlign: 'baseline',
      // justifyContent: 'center',
    },
    available: {
      fontSize: '12px',
      color: '#5D995C',
      whiteSpace: 'nowrap',
    },
    unavailable: {
      fontSize: '12px',
      color: '#D53C2F',
    },
    description: {
      fontSize: '12px',
      lineHeight: '18px',
      color: '#939393', // TODO get from settings
      // color: theme.colors.secondaryTextColour,
      // height: '100%',
    },
    right: {
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      textAlign: 'right',
    },
    price: {
      fontFamily: theme.baseTypography.numberFontFamily,
    },
    selectLabel: {
      width: '64px',
      fontSize: '14px',
    },
    image: {
      height: '110px',
      width: '110px',
      borderRadius: '6px',
      flexShrink: 0,
      // backgroundColor: 'white',
    },
  }),
  { name: 'ExperienceCard' },
);

export default useStyles;
